/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { USER_STATUS, apiUrlB2B, } from '../../../../utils/constants';
import UFInput from '../../../../components/Input/UFInput';
import { classifyPhoneNumber, decodeAtob, addCountryCode, axiosInstance } from '../../../../utils/helper';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Loader from '../../../../components/Loader';
import { setUser } from '../../../../store/reducers/user';
import useToast from '../../../../components/Toast';
import useNavigation from '../../../../hook/useNavigation';
import { setCompany } from '../../../../store/reducers/ufood-x/company';

const NamePhone = ({ onClose }) => {
	const dispatch = useDispatch();
	const navigate = useNavigation();

	const { showToast } = useToast();

	const user = useSelector((store) => store?.user || {});
	const company = useSelector((store) => store?.company || {});
	const [isLoading, setIsLoading] = useState(false);

	const userSchema = Yup.object().shape({
		firstName: Yup.string().required('Nama kontak wajib diisi'),
		primary_phone: Yup.string()
			.required('Nomor kontak wajib diisi')
			.test('is-mobile-phone', 'Hanya nomor ponsel yang diperbolehkan', (value) => {
				if (!value) return false;
				const result = classifyPhoneNumber(value);
				return result.type === 'mobile';
			}),
	});

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			firstName: user?.firstName ?? '',
			primary_phone: user?.primary_phone ?? '',
		},
		validationSchema: userSchema,
		onSubmit: async (values, { resetForm }) => {
			await handleSave(values, resetForm);
		},
	});

	const { errors, touched, handleSubmit, values, setValues } = formik;

	const handleSave = async (values) => {
		console.log('handleSave');
		try {
			setIsLoading(true);
			const payload = {
				customerName: values?.firstName,
				phoneNumber: addCountryCode(values?.primary_phone),
				companyId: String(company?.companyID),
			};

			const res = await axiosInstance.put(
				`auth-ufoodx/update-customer/${user?.customerID}`,
				payload,
        {
          baseURL: apiUrlB2B
        }
			);

			if (res?.data?.statusCode !== 200) {
				showToast('error', res?.data?.message, 5000);
			}

			const { token, refreshToken, customerData } = res?.data?.data;

			const dataCustomer = decodeAtob(customerData);
			const parseCustomer = JSON.parse(dataCustomer);

      const userData = {
        firstName: parseCustomer?.firstName,
        lastName: parseCustomer?.lastName,
        email: parseCustomer?.email,
        primary_phone: parseCustomer?.primary_phone,
        customerID: parseCustomer?.customerID,
        companyID: parseCustomer?.companyID,
        companyName: parseCustomer?.companyName,
        paymentMethod: parseCustomer?.paymentMethod?.toLowerCase(),
        birthDate: parseCustomer?.birthDate,
        gender: parseCustomer?.customerGender,
        status: parseCustomer?.customerStatus || USER_STATUS.PENDING,
		is_b2b: true,
      };

			dispatch(
				setUser({
					token: token,
					refresh_token: refreshToken,
					...userData,
				}),
			);

      if (Boolean(parseCustomer?.loyalty)) {
        const companyData = {
          companyLoyaltyPassword: parseCustomer?.companyLoyaltyPassword,
          companyLoyaltyUrl: parseCustomer?.companyLoyaltyUrl,
          companyLoyaltyUsername: parseCustomer?.companyLoyaltyUsername,
          loyalty: parseCustomer?.loyalty,
          companyLoyaltyWidgetUrl: parseCustomer?.companyLoyaltyWidgetUrl,
          companyLoyaltyClientCode: parseCustomer?.companyLoyaltyClientCode,
        };
        dispatch(setCompany(companyData));
      }

			setIsLoading(false);
			onClose?.();
			navigate.push('/ufood-x/summary');
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
			showToast('error', error.message, 5000);
		}
	};

	return (
		<>
			{isLoading && <Loader overlay />}

			<div className="fixed inset-0 z-50 flex items-center justify-center">
				<div
					className="absolute inset-0 bg-black/40"
					onClick={onClose}
				/>
				<div className="relative bg-white w-full max-w-md rounded-lg shadow-lg z-10 max-h-[90vh] overflow-y-auto">
					<div className="flex justify-between items-center p-4 border-b">
						<h2 className="text-sm font-semibold">
							Lengkapi Data
						</h2>
						<button
							onClick={onClose}
							className="text-gray-400 hover:text-gray-600"
						>
							✕
						</button>
					</div>

					<div className="p-4">
						<div className="py-2">
							<UFInput
								label="Nama Kontak"
								required
								type="text"
								placeholder="e.g. Jhon doe"
								value={values?.firstName}
								errorMessage={
									touched?.firstName &&
									errors?.firstName &&
									errors?.firstName
								}
								onChange={(event) => {
									setValues((prev) => ({
										...prev,
										firstName: event.target.value,
									}));
								}}
								maxLength={25}
								disabled={isLoading}
							/>

							<UFInput
								label="Nomor Kontak"
								required
								type="tel"
								placeholder="e.g. 81234567890"
								value={values?.primary_phone}
								errorMessage={
									touched?.primary_phone &&
									errors?.primary_phone &&
									errors?.primary_phone
								}
								onChange={(event) => {
									let raw = event.target.value;
									let onlyNumbers = raw.replace(/\D/g, '');

									if (onlyNumbers.startsWith('0')) {
										onlyNumbers = '8' + onlyNumbers.slice(1);
									}

									setValues((prev) => ({
										...prev,
										primary_phone: onlyNumbers,
									}));
								}}
								maxLength={15}
								disabled={isLoading}
								countryCode={'+62'}
							/>

							<button
								type="button"
								className="mt-4 border border-solid border-[var(--rose-violet)] bg-[var(--rose-violet)] text-white w-full py-2.5 text-xs font-semibold rounded disabled:opacity-50"
								onClick={handleSubmit}
								disabled={isLoading}
							>
								Simpan
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default NamePhone;
